import { DisponibilidadeCapacidadeCargaContainer } from "app/components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeCargaContainer";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";
import { ControllerBase } from "controllerBase";
import global from 'globalMU';
import React from "react";
import { FinalizarOrcamentoContainer } from "../../components/finalizar-orcamento/FinalizarOrcamentoContainer";

const moment = require('moment');
const ko = require('knockout')

declare const window:WindowMU 
declare const orcamentoController:any
declare const NumeroPedidoView:any
declare const orcamentoUtil:any
 

var $boolFinalizarOrcamentoExecutouAposBinding = false;


const FinalizarOrcamentoController = ControllerBase.extend({
    name: "FinalizarOrcamentoController",

    framework: "knockout",

    ajax: function () {
    },

    events: {    },

    formConfig: {    },

    antesBinding: function () {},
    aposBinding: function () {},
    renderizado: function () {},

    atualizarCalendariosCapacidadeCarga: async function() {},
    renderizacaoCompleta: async function () {},
    pesquisarDisponibilidadeCargaCalendario: function (e) {},
    situacaoOrcamentoAlterada: function (e) {},
    ConfirmarNovaData: function (e) {},
    liberarPendencias: function () {},

    alterarExibicao: function () {},
    
    tratarRespostas: function () {},

    atacharEventos: function () {},

    possuiPerguntaSemResposta: function () {},

    finalizarOrcamento: function (e) {},

    obterInformacoesEmail: function (callback) {},

    validarImpressaoOrcamento: function (e) {},

    senhaKeyUp: function (model, e) {},

    obterCodigoFilial: function () {},

    DefinirRespostaInconsistencia: function (data, valor) {},

});

window.FinalizarOrcamentoController = FinalizarOrcamentoController

export {
    FinalizarOrcamentoController
};

